/**
 * Detects if the user is on an Android device
 */
export const isAndroid = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  return /android/i.test(userAgent);
};

/**
 * Detects if the user is on an iOS device
 */
export const isIOS = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  return /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
};

/**
 * Detects if the user is on a mobile device
 */
export const isMobile = (): boolean => {
  return isAndroid() || isIOS();
};

/**
 * Detects if the app is running in the Upmindy mobile app webview
 * NOTE: This will return FALSE for regular mobile browsers (Chrome, Safari, etc.)
 * Only returns TRUE when running inside the Upmindy native app
 */
export const isUpmindyWebView = (): boolean => {
  const userAgent = navigator.userAgent || '';
  return /UpmindyApp/i.test(userAgent);
};

/**
 * Detects if the app is running in the Upmindy Android mobile app webview
 * NOTE: This will return FALSE for Android phones using regular browsers
 * Only returns TRUE when running inside the Upmindy Android app
 */
export const isUpmindyAndroidWebView = (): boolean => {
  const userAgent = navigator.userAgent || '';
  return /UpmindyApp\/Android/i.test(userAgent);
};

/**
 * Detects if the app is running in the Upmindy iOS mobile app webview
 * NOTE: This will return FALSE for iPhones using Safari or other browsers
 * Only returns TRUE when running inside the Upmindy iOS app
 */
export const isUpmindyIOSWebView = (): boolean => {
  const userAgent = navigator.userAgent || '';
  return /UpmindyApp\/iOS/i.test(userAgent);
};
